import { Link } from 'react-router-dom';

interface CategoryItem {
  id: string;
  name: string;
  slug: string;
  description: string;
}

const categoryData: CategoryItem[] = [
  { id: 'romance', name: '恋爱言情', slug: 'romance', description: '甜宠恋爱 · 校园纯爱' },
  { id: 'fantasy', name: '奇幻冒险', slug: 'fantasy', description: '异世界 · 魔法战斗' },
  { id: 'action', name: '热血动作', slug: 'action', description: '格斗竞技 · 超能战斗' },
  { id: 'drama', name: '剧情悬疑', slug: 'drama', description: '烧脑推理 · 心理博弈' },
  { id: 'comedy', name: '搞笑日常', slug: 'comedy', description: '轻松搞笑 · 治愈日常' },
  { id: 'horror', name: '惊悚恐怖', slug: 'horror', description: '悬疑惊悚 · 灵异怪谈' },
];

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            精选分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            六大分类，总有一款适合你的口味
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categoryData.map((cat, index) => {
            const isFeatured = index === 0 || index === 3;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`group relative overflow-hidden rounded-xl p-5 md:p-6 flex flex-col items-center text-center transition-all duration-300 cursor-pointer ${
                  isFeatured
                    ? 'bg-foreground-950 hover:bg-foreground-900'
                    : 'bg-background-50 hover:bg-background-50/80'
                }`}
              >
                {isFeatured && (
                  <div className="absolute top-0 right-0 w-16 h-16 bg-accent-500/20 rounded-bl-full"></div>
                )}
                <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl mb-3 md:mb-4 transition-transform duration-300 group-hover:scale-110 ${
                  isFeatured
                    ? 'bg-white/10'
                    : 'bg-background-200'
                }`}>
                  <i className={`text-xl md:text-2xl ${
                    isFeatured ? 'text-white' : 'text-foreground-700'
                  } ${getCategoryIcon(cat.id)}`}></i>
                </div>
                <h3 className={`text-sm md:text-base font-semibold mb-1 ${
                  isFeatured ? 'text-white' : 'text-foreground-950'
                }`}>
                  {cat.name}
                </h3>
                <p className={`text-xs ${
                  isFeatured ? 'text-white/50' : 'text-foreground-400'
                }`}>
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function getCategoryIcon(id: string): string {
  const icons: Record<string, string> = {
    romance: 'ri-heart-line',
    fantasy: 'ri-magic-line',
    action: 'ri-fire-line',
    drama: 'ri-search-eye-line',
    comedy: 'ri-emotion-laugh-line',
    horror: 'ri-ghost-line',
  };
  return icons[id] || 'ri-book-open-line';
}